import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { IconsService } from './icons.service';

export function provideIcons(): Array<Provider | EnvironmentProviders> {
  return [
    provideEnvironmentInitializer(() => inject(IconsService))
  ];
}
